import { createContext } from 'react'

export interface ThemeContextValue {
  themeId: string;
  setThemeId: (mode: string) => void;
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)
